import React, { useEffect, useState } from "react";
import portpic from "../../../../assets/images/wired.svg";
import errorIcon from "../../../../assets/images/error-2.png";
import allApi from "../../../../api/allApi";
import { all } from "axios";
import { useViewTransitionState } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { arrayIncludes } from "@mui/x-date-pickers/internals/utils/utils";
import { responsiveFontSizes } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useLocalization } from "../../localization/LocalizationContext";
import { useNetwork } from "../../common/networkContext";

function DowntimeSchedules({ scheduleModal, setScheduleModal }) {
  const { localizationStrings } = useLocalization();
  const { selectedNetworkId, selectedLocation } = useNetwork();
  const networkId = selectedNetworkId?.id ?? 6001;
  const [portModel, setPortModel] = useState(false);
  const [listModel, setListModel] = useState(true);
  const [initialPage, setInitialPage] = useState(false);
  const [editScheduleModel, setEditScheduleModel] = useState(false);
  const [editPortModel, setEditPortModel] = useState(false);
  const [scheduleList, setScheduleList] = useState([]);
  const [scheduleData, setScheduleData] = useState({});
  const [portDetailsData, setPortDetailsData] = useState([]);
  const [deleteScheduleModel, setDeleteScheduleModel] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showEditPortSuccessPopup, setShowEditPortSuccessPopup] =
    useState(false);
  const [showEditSuccessPopup, setShowEditSuccessPopup] = useState(false);
  const [networkList, setNetworkList] = useState([]);
  const [selectedNetwork, setSelectedNetwork] = useState("");

  const [schedule, setSchedule] = useState({
    name: "",
    networkId: "",
    allDay: "0",
    startTime: null,
    endTime: null,
    recurrence: {
      type: 0,
      startDate: null,
      endDate: null,
      weekDay: [],
    },
  });
  const [editScheduleData, setEditScheduleData] = useState({
    schdName: "",
    allDay: "0",
    startTime: null,
    endTime: null,
    recurrenceType: 0,
    recurrenceStartDate: null,
    recurrenceEndDate: null,
    recurrenceWeekDay: [],
  });
  const [applySchedule, setApplySchedule] = useState({
    scheduleId: 8,
    portDetails: [
      {
        deviceId: 2103,
        ports: ["3", "6"],
      },
    ],
  });
  const [editPortsData, setEditPortsData] = useState({
    deviceId: null,
    portDetails: [],
  });
  const [assignedEditPorts, setAssignedEditPorts] = useState({});
  const [enableSchedule, setEnableSchedule] = useState(false);
  const [scheduleId, setScheduleId] = useState();
  const [assignedPorts, setAssignedPorts] = useState({});
  const [info, setInfo] = useState(null);
  const [selectedPorts, setSelectedPorts] = useState([]);
  const [responseId, setResponseId] = useState(null);
  const [id,setId] = useState(null);
  const [showScheduleFailurePopup,setShowScheduleFailurePopup] = useState(false);
  const [showEditFailurePopup,setShowEditFailurePopup] = useState(false);

  useEffect(() => {
    fetchSchedule(networkId);
  }, [networkId]);


  useEffect(() => {
  const fetchNetworks = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/network/getAssociatedNetwork");

      if (
        response.status === "OK" &&
        Array.isArray(response.response)
      ) {
        setNetworkList(
        response.response.map((network) => ({
          network_id: network.network_id,
          network_name: network.network_name,
        }))
      );
      }
    } catch (error) {
      console.error("Error fetching networks", error);
      setNetworkList([]);
    }
  };

  fetchNetworks();
}, []);

  const handleEditClick = (schedule) => {
    editSchedule(schedule.swSchdId);
  };
  const handleEditPortClick = (schedule) => {
    editPortDetails(schedule.swSchdId);
  };
  const handleUpdateScheduleClick = (id) => {
    updateSchedule(id);
  };

  const handleUpdatePortClick = async (
    editPortsData,
    assignedEditPorts,
    swSchdId
  ) => {
    try {
      await updateApplySchedule(editPortsData, assignedEditPorts, swSchdId);
      setEditPortModel(false);
    } catch (error) {
      console.error("Failed to update port details", error);
    }
  };
  const handleCancelPopUp = () => {
    setShowSuccessPopup(false);
    setShowEditPortSuccessPopup(false);
    setShowEditSuccessPopup(false);
  };

  const updateScheduleField = (field, value) => {
    setSchedule((prevSchedule) => ({
      ...prevSchedule,
      [field]:
        field === "startTime" || field === "endTime"
          ? value
            ? dayjs(value).format("HH:mm")
            : null
          : value,
    }));
  };

  const updateRecurrenceField = (field, value) => {
    setSchedule((prevSchedule) => ({
      ...prevSchedule,
      recurrence: {
        ...prevSchedule.recurrence,
        [field]:
          field === "startDate" || field === "endDate"
            ? value
              ? dayjs(value).format("YYYY-MM-DD")
              : null
            : value,
      },
    }));
  };
  const updateEditScheduleField = (field, value) => {
    setEditScheduleData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const updateEditRecurrenceField = (field, value) => {
    setEditScheduleData((prev) => ({
      ...prev,
      recurrence: { ...prev.recurrence, [field]: value },
    }));
  };

  const updateApplyScheduleFields = (field, value) => {
    setApplySchedule({
      ...applySchedule,
      [field]: value,
    });
  };

  const fetchSchedule = async (networkId) => {
    try {
      const api = new allApi();
      const response = await api.getRequest(`api/wired/conf/schedules/all?networkId=${networkId}`);
      if (response.data && Array.isArray(response.data)) {
        setScheduleList(response.data);
      } else {
        console.error("Invalid response format", response);
      }
    } catch (error) {
      console.error("Error fetching schedules:", error);
    }
  };

  const handleSwitch = (data) => {
    if (data && data.length > 0) {
      setListModel(true);
      setInitialPage(false);
    } else {
      setListModel(false);
      setInitialPage(true);
    }
  };

  const handleScheduleTime = () => {
    setScheduleModal(false);
    setPortModel(false);
    setInitialPage(false);
    setListModel(true);
  };

  const addApplySchedule = async () => {
    try {
      const api = new allApi();

      const portDetails = info?.switchDetails?.map((device) => ({
        deviceId: device.device_id,
        ports: Object.keys(assignedPorts)
          .filter((port) => assignedPorts[port])
          .map((port) => port.toString()),
      }));

      const payload = {
        scheduleId: responseId,
        portDetails: portDetails || [],
      };
      const response = await api.postRequest(
        "api/wired/conf/poePortDetails/add",
        " ",
        payload
      );
      if (response) {
        setPortModel(false);
        setShowSuccessPopup(true);
      }
    } catch (error) {
      console.error("Error applying schedule:", error);
      alert("Failed to apply schedule.");
    }
  };

  // const fetchSchedule = async() =>{
  //   try{
  //    const api = new allApi();
  //    const response = await api.getRequest("api/wired/conf//schedules/all");
  //    if(response){
  //     setScheduleList(response);
  //    }
  //   }catch(error){
  //    console.log("Error in fetching schedule",error);
  //
  // }

  const addSchedule = async (param) => {
    try {
      const api = new allApi();
      const payload = {
        poeSchedule: {
          name: schedule.name,
          allDay: schedule.allDay,
          startTime: schedule.startTime,
          endTime: schedule.endTime,
          recurrence: {
            type: schedule.recurrence.type,
            startDate: schedule.recurrence.startDate,
            endDate: schedule.recurrence.endDate,
            weekDay: schedule.recurrence.weekDay,
          },
        },
      };
      const response = await api.postRequest(
        "api/wired/conf/poeSchedule/addAndChoosePorts",
        "",
        payload
      );
      if (response.status === "200") {
        param == "save" &&
          setShowSuccessPopup(true) &&
          fetchSchedule() &&
          cancelSchedule();
        setResponseId(response.scheduleId);
        setInfo(response);
        cancelSchedule();
        //setShowSuccessPopup(true);
      }else{
        setShowScheduleFailurePopup(true);
      }
    } catch (error) {
      console.error("Error adding downtime schedule", error);
    }
  };

  const updateSchedule = async (id) => {
    try {
      const api = new allApi();
      const payload = {
        poeSchedule: {
          name: editScheduleData.schdName,
          allDay: String(editScheduleData.allDay),
          startTime: editScheduleData.startTime,
          endTime: editScheduleData.endTime,
          recurrence: {
            type: editScheduleData.recurrenceType,
            startDate: editScheduleData.recurrenceStartDate
              ? dayjs(editScheduleData.recurrenceStartDate).format("YYYY-MM-DD")
              : null,
            endDate: editScheduleData.recurrenceEndDate
              ? dayjs(editScheduleData.recurrenceEndDate).format("YYYY-MM-DD")
              : null,
            weekDay: editScheduleData.recurrenceWeekDay || [],
          },
        },
      };

      const response = await api.putRequest(
        `api/wired/conf/poeSchedule/edit?scheduleId=${id}`,
        payload
      );

      if (response.status === "200") {
        setEditScheduleModel(false);
        setShowEditSuccessPopup(true);
        fetchSchedule();
      } else {
        setShowEditFailurePopup(true);
        console.error("API response is empty or invalid.");
      }
    } catch (error) {
      console.error("Error in updating schedules:", error);
    }
  };

  const updateApplySchedule = async (editPortsData, assignedEditPorts) => {
    try {
      const selectedPorts = Object.keys(assignedEditPorts)
        .filter((port) => assignedEditPorts[port])
        .map(Number);

      const payload = {
        scheduleId: editPortsData.idss,
        portDetails: [
          {
            deviceId: editPortsData.deviceId,
            ports: selectedPorts,
          },
        ],
      };
      const api = new allApi();
      const response = await api.putRequest(
        "api/wired/conf/poePortDetails/edit",
        payload
      );

      if (response) {
        setShowEditPortSuccessPopup(true);
        return response;
      }
    } catch (error) {
      console.error("Error in updating schedule", error);
      throw error;
    }
  };

  const deleteSchedule = async (swSchdId) => {
    try {
      const api = new allApi();
      const response = await api.deleteRequest(
        `api/wired/conf/poePortDetails/delete?scheduleId=${swSchdId}`
      );
      if (response) {
        fetchSchedule();
        setDeleteScheduleModel(false);
      }
    } catch (error) {
      console.error("Error in deleting downtime schedule", error);
    }
  };

  const toggleScheduleApi = async (swSchdId, enable) => {
    try {
      const api = new allApi();
      const payload = {
        scheduleId: swSchdId,
        enable: enable,
      };
      const response = await api.postRequest(
        "api/wired/conf/managePoE",
        "",
        payload
      );
      if (response) {
        setEnableSchedule(enable);
      }
    } catch (error) {
      console.error(
        `Error ${
          enable ? "enabling" : "disabling"
        } schedule with ID ${swSchdId}:`,
        error
      );
    }
  };

  // const getInfo = async (responseId) => {
  //   try {
  //     const api = new allApi();
  //     const response = await api.getRequest(`api/wired/conf/switchDetails?scheduleId=${responseId}`);
  //     if (response && Array.isArray) {
  //       setInfo(response);
  //     }
  //   } catch (error) {
  //     console.error("Error in fetching info", error);
  //   }
  // };

  const handleToggle = (schedule) => {
    toggleScheduleApi(schedule.swSchdId, !enableSchedule);
  };

  const updateScheduleState = (swSchdId, newState) => {
    setScheduleList((prevList) =>
      prevList.map((schedule) =>
        schedule.swSchdId === swSchdId
          ? { ...schedule, enabled: newState }
          : schedule
      )
    );
  };

  const editSchedule = async (swSchdId) => {
    try {
      const api = new allApi();
      const response = await api.getRequest(
        `api/wired/conf/schedules/${swSchdId}`
      );
      if (response) {
        const processedResponse = {
          ...response,
          startTime: response.startTime
            ? dayjs(response.startTime, "HH:mm:ss").format("HH:mm")
            : "",
          endTime: response.endTime
            ? dayjs(response.endTime, "HH:mm:ss").format("HH:mm")
            : "",
        };

        setEditScheduleData(processedResponse);
        setId(processedResponse.swSchdId);
        setEditScheduleModel(true);
      }
    } catch (error) {
      console.error("Error fetching schedule data:", error);
    }
  };

  const editPortDetails = async (swSchdId) => {
    try {
      const api = new allApi();
      const response = await api.getRequest(
        `api/wired/conf/poePortDetails/${swSchdId}`
      );

      if (response && Array.isArray(response)) {
        const fetchedSwSchdId = response[0]?.swSchdId.swSchdId || null;

        const portDetails = response[0]?.portDetails || [];
        const deviceId = response[0]?.deviceId || null;

        setEditPortsData({
          deviceId,
          portDetails,
          idss: fetchedSwSchdId,
        });

        const initialAssignedPorts = {};
        portDetails.forEach((port) => {
          initialAssignedPorts[port] = true;
        });
        setAssignedEditPorts(initialAssignedPorts);
        setEditPortModel(true);
      } else {
        console.warn("Unexpected API response format", response);
      }
    } catch (error) {
      console.error("Error fetching port details", error);
    }
  };

  const cancelSchedule = () => {
    setSchedule({
      name: "",
      allDay: "0",
      startTime: null,
      endTime: null,
      recurrence: {
        type: 2,
        startDate: null,
        endDate: null,
        weekDay: [],
      },
    });
    setScheduleModal(false);
  };

  const togglePort = (portNumber) => {
    setAssignedPorts((prev) => ({
      ...prev,
      [portNumber]: !prev[portNumber],
    }));
  };
  const toggleEditPort = (portNumber) => {
    setAssignedEditPorts((prev) => ({
      ...prev,
      [portNumber]: !prev[portNumber],
    }));
  };

  const disableSave = !(schedule.name && schedule.allDay && schedule.recurrence.type && schedule.recurrence.endDate && schedule.recurrence.weekDay);
  
  return (
    <div>
      {listModel && scheduleList.length > 0 ? (
        <div className="poe-schedule w-scroll">
          <div className="accordion mt-4" id="poeSchedule">
            {scheduleList.map((schedule, index) => (
              <div className="accordion-item" key={schedule.swSchdId}>
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button
                    className={`accordion-button ${
                      index !== 0 ? "collapsed" : ""
                    }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded={index === 0}
                    aria-controls={`collapse${index}`}
                  >
                    {schedule.schdName}
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className={`accordion-collapse collapse ${
                    index === 0 ? "show" : ""
                  }`}
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#poeSchedule"
                >
                  <div className="accordion-body">
                    <div className="schedule-action">
                      <div className="tab-form">
                        <div className="switch-box">
                          <strong>
                            {localizationStrings?.enableScheduledDowntime}
                          </strong>
                          <label className="ice-switch">
                            <input
                              type="checkbox"
                              checked={enableSchedule}
                              onChange={() => handleToggle(schedule)}
                            />
                            <span className="slider"></span>
                          </label>
                        </div>
                      </div>
                      <div className="schedule-btn">
                        <button
                          type="button"
                          className="btn btn-outline"
                          onClick={() => handleEditClick(schedule)}
                        >
                          {localizationStrings?.edit}
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline"
                          onClick={() => handleEditPortClick(schedule)}
                        >
                          {localizationStrings?.editPorts}
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline"
                          onClick={() => {
                            setScheduleId(schedule.swSchdId);
                            setDeleteScheduleModel(true);
                          }}
                        >
                          {localizationStrings?.delete}
                        </button>
                      </div>
                      {schedule.recurrenceType === "2" && (
                        <div className="row mt-3 mb-3">
                          <div className="col-lg-12">
                            <div className="weekdays">
                              {["S", "M", "T", "W", "TH", "F", "S"].map(
                                (day, index) => {
                                  const dayNumber = (index + 1).toString();
                                  return (
                                    <label key={dayNumber}>
                                      <input
                                        type="checkbox"
                                        checked={schedule.recurrenceWeekDay.includes(
                                          dayNumber
                                        )}
                                        value={schedule.recurrenceWeekDay}
                                      />
                                      <span>{day}</span>
                                    </label>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="poe-schdule-time">
                      <div>
                        <span>{localizationStrings?.timeRange}</span>
                        <strong>
                          {schedule.startTime} - {schedule.endTime}
                        </strong>
                      </div>
                      <div>
                        <span>{localizationStrings?.recurrence}</span>
                        <strong>
                          {schedule.recurrenceStartDate} -{" "}
                          {schedule.recurrenceEndDate}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <p className="mt-4">
            {localizationStrings?.resetSwichInfo}{" "}
            <i className="fa fa-angle-right" aria-hidden="true"></i>{" "}
            {localizationStrings?.poeManagement}
          </p>
        </div>
      ) : (
        <div className="poe-schedule-banner">
          <div>
            <img src={portpic} alt="Port" />
            <p>{localizationStrings?.downtimeScheduleInfo}</p>
            <button
              className="text-btn primary-btn"
              onClick={() => setScheduleModal(true)}
            >
              {localizationStrings?.createPoeDowntimeSchedule}
            </button>
          </div>
        </div>
      )}

      {scheduleModal && (
        <div className="customModal">
          <div className="c-modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {localizationStrings?.createNewPoEDowntimeSchedule}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => cancelSchedule()}
                ></button>
              </div>
              <div className="modal-body add-ssid-body">
                <p>{localizationStrings?.scheduleSetInfo}</p>
                <div className="row mb-4">
                  <div className="col-lg-6">
                    <label htmlFor="ScheduleName" className="col-form-label">
                      {localizationStrings?.scheduleName}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="ScheduleName"
                      placeholder="Schedule Name"
                      value={schedule.name}
                      onChange={(e) =>
                        updateScheduleField("name", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-lg-6">
                    <label htmlFor="NetworkName" className="col-form-label">
                      {localizationStrings?.networkName}
                    </label>
                   <select
  className="form-select"
  value={selectedNetwork}
  onChange={(e) => {
    const value = e.target.value;
    setSelectedNetwork(value);
    updateScheduleField("networkId", value);
  }}
>
  <option value="" disabled>
    {localizationStrings?.selectNetwork || "Select Network"}
  </option>

  {networkList.map((network) => (
    <option key={network.network_id} value={network.network_id}>
      {network.network_name}
    </option>
  ))}
</select>
                  </div>
                </div>

                <div className="border-line"></div>
                <h4 className="mt-3">{localizationStrings?.downntimeRange}</h4>
                <p>{localizationStrings?.scheduleRangeInfo}</p>

                <div className="row mb-3">
                  <div className="col-lg-6">
                    <div className="tab-form">
                      <div className="switch-box">
                        <strong>{localizationStrings?.allDay}</strong>
                        <label className="ice-switch">
                          <input
                            type="checkbox"
                            checked={schedule.allDay === "1"}
                            onChange={(e) =>
                              updateScheduleField(
                                "allDay",
                                e.target.checked ? "1" : "0"
                              )
                            }
                          />
                          <span className="slider"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {schedule.allDay === "0" && (
                  <div className="row mb-4">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="col-lg-4">
                        {/* Start Time */}
                        <label htmlFor="StartOn" className="col-form-label">
                          {localizationStrings?.startOn}
                        </label>
                        <TimePicker
                          slotProps={{ textField: {} }}
                          value={
                            schedule.startTime
                              ? dayjs(schedule.startTime, "HH:mm")
                              : null
                          }
                          onChange={(newValue) =>
                            updateScheduleField("startTime", newValue)
                          }
                        />
                      </div>
                      <div className="col-lg-4">
                        {/* End Time */}
                        <label htmlFor="EndOn" className="col-form-label">
                          {localizationStrings?.endOn}
                        </label>
                        <TimePicker
                          slotProps={{ textField: {} }}
                          value={
                            schedule.endTime
                              ? dayjs(schedule.endTime, "HH:mm")
                              : null
                          }
                          onChange={(newValue) =>
                            updateScheduleField("endTime", newValue)
                          }
                        />
                      </div>
                    </LocalizationProvider>
                  </div>
                )}
                <div className="border-line"></div>

                <h4 className="mt-3">{localizationStrings?.recurrence}</h4>
                <div className="row">
                  <div className="col-lg-6">
                    <label htmlFor="Recurrence" className="col-form-label">
                      {localizationStrings?.recurrenceType}
                    </label>
                    <select
                      id="securityAuthentication"
                      className="form-select"
                      value={schedule.recurrence.type}
                      onChange={(e) =>
                        updateRecurrenceField(
                          "type",
                          parseInt(e.target.value, 10)
                        )
                      } // Convert to integer
                    >
                      <option value={0}>{localizationStrings?.none}</option>
                      <option value={1}>{localizationStrings?.daily}</option>
                      <option value={2}>{localizationStrings?.weekly}</option>
                    </select>
                  </div>
                </div>

                {schedule.recurrence.type == 2 && (
                  <div className="row mt-3 mb-3">
                    <div className="col-lg-12">
                      <p>{localizationStrings?.scheduleSelectInfo}</p>
                      <div className="weekdays">
                        {["S", "M", "T", "W", "TH", "F", "S"].map(
                          (day, index) => {
                            const dayNumber = (index + 1).toString();
                            return (
                              <label key={dayNumber}>
                                <input
                                  type="checkbox"
                                  checked={schedule.recurrence.weekDay.includes(
                                    dayNumber
                                  )}
                                  onChange={() => {
                                    const updatedDays =
                                      schedule.recurrence.weekDay.includes(
                                        dayNumber
                                      )
                                        ? schedule.recurrence.weekDay.filter(
                                            (d) => d !== dayNumber
                                          )
                                        : [
                                            ...schedule.recurrence.weekDay,
                                            dayNumber,
                                          ];
                                    setSchedule((prev) => ({
                                      ...prev,
                                      recurrence: {
                                        ...prev.recurrence,
                                        weekDay: updatedDays,
                                      },
                                    }));
                                  }}
                                />
                                <span>{day}</span>
                              </label>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="col-lg-4">
                      <label htmlFor="StartOn" className="col-form-label">
                        {localizationStrings?.startDate}
                      </label>
                      <DatePicker
                        slotProps={{ textField: {} }}
                        value={
                          schedule.recurrence.startDate
                            ? dayjs(schedule.recurrence.startDate)
                            : null
                        }
                        onChange={(newValue) =>
                          updateRecurrenceField("startDate", newValue)
                        }
                        minDate={dayjs()} // Prevent past dates
                      />
                    </div>
                    <div className="col-lg-4">
                      <label htmlFor="EndOn" className="col-form-label">
                        {localizationStrings?.endDate}
                      </label>
                      <DatePicker
                        slotProps={{ textField: {} }}
                        value={
                          schedule.recurrence.endDate
                            ? dayjs(schedule.recurrence.endDate)
                            : null
                        }
                        onChange={(newValue) =>
                          updateRecurrenceField("endDate", newValue)
                        }
                        minDate={
                          schedule.recurrence.startDate
                            ? dayjs(schedule.recurrence.startDate)
                            : dayjs()
                        }
                      />
                    </div>
                  </LocalizationProvider>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={() => cancelSchedule()}
                >
                  {localizationStrings?.cancel}
                </button>
                <button
                  type="button"
                  className="text-btn primary-btn"
                  disabled = {disableSave}
                  onClick={() => {
                    setPortModel(true);
                    setScheduleModal(false);
                    addSchedule("save&choose");
                  }}
                >
                  {localizationStrings?.saveAndChoosePorts}
                </button>
                <button
                  type="button"
                  className="text-btn primary-btn"
                  disabled = {disableSave}
                  onClick={() => {
                    addSchedule("save");
                    setScheduleModal(false);
                    setInitialPage(false);
                    setListModel(true);
                  }}
                >
                  {localizationStrings?.save}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {editScheduleModel && (
        <div className="customModal">
          <div className="c-modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {localizationStrings?.editPoeDowntimeSchedule}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditScheduleModel(false)}
                ></button>
              </div>
              <div className="modal-body add-ssid-body">
                <p>{localizationStrings?.scheduleSetInfo}</p>
                <div className="row mb-4">
                  <div className="col-lg-6">
                    <label htmlFor="ScheduleName" className="col-form-label">
                      {localizationStrings?.scheduleName}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="ScheduleName"
                      placeholder="Schedule Name"
                      value={editScheduleData?.schdName}
                      onChange={(e) =>
                        updateEditScheduleField("schdName", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-lg-6">
                    <div className="switch-box">
                      <strong>{localizationStrings?.allDay}</strong>
                      <label className="ice-switch">
                        <input
                          type="checkbox"
                          checked={editScheduleData?.allDay == 1}
                          onChange={(e) =>
                            updateEditScheduleField(
                              "allDay",
                              e.target.checked ? 1 : 0
                            )
                          }
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row mb-4">
                  {editScheduleData?.startTime && editScheduleData?.endTime && (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="row mb-4">
                        <div className="col-lg-4">
                          <label htmlFor="StartOn" className="col-form-label">
                            {localizationStrings?.startOn}
                          </label>
                          <TimePicker
                            slotProps={{ textField: {} }}
                            value={dayjs(editScheduleData.startTime, "HH:mm")}
                            onChange={(newValue) =>
                              updateEditScheduleField(
                                "startTime",
                                newValue ? newValue.format("HH:mm") : ""
                              )
                            }
                          />
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="EndOn" className="col-form-label">
                            {localizationStrings?.endOn}
                          </label>
                          <TimePicker
                            slotProps={{ textField: {} }}
                            value={dayjs(editScheduleData.endTime, "HH:mm")}
                            onChange={(newValue) =>
                              updateEditScheduleField(
                                "endTime",
                                newValue ? newValue.format("HH:mm") : ""
                              )
                            }
                          />
                        </div>
                      </div>
                    </LocalizationProvider>
                  )}
                </div>

                <div className="row">
                  <div className="col-lg-6">
                    <label htmlFor="Recurrence" className="col-form-label">
                      {localizationStrings?.recurrenceType}
                    </label>
                    <select
                      id="recurrenceType"
                      className="form-select"
                      value={editScheduleData?.recurrenceType}
                      onChange={(e) => {
                        const newType = parseInt(e.target.value, 10);
                        setEditScheduleData((prev) => ({
                          ...prev,
                          recurrenceType: newType,
                          recurrenceWeekDay:
                            newType === 2 ? prev.recurrenceWeekDay : [],
                        }));
                      }}
                    >
                      <option value={0}>{localizationStrings?.none}</option>
                      <option value={1}>{localizationStrings?.daily}</option>
                      <option value={2}>{localizationStrings?.weekly}</option>
                    </select>
                  </div>
                </div>
                {editScheduleData?.recurrenceType == 2 && (
                  <div className="row mt-3 mb-3">
                    <div className="col-lg-12">
                      <p>{localizationStrings?.selectRangeInfo}</p>
                      <div className="weekdays">
                        {["S", "M", "T", "W", "TH", "F", "S"].map(
                          (day, index) => {
                            const dayNumber = (index + 1).toString();
                            return (
                              <label key={dayNumber}>
                                <input
                                  type="checkbox"
                                  checked={editScheduleData?.recurrenceWeekDay.includes(
                                    dayNumber
                                  )}
                                  onChange={() => {
                                    setEditScheduleData((prev) => {
                                      const updatedDays =
                                        prev.recurrenceWeekDay.includes(
                                          dayNumber
                                        )
                                          ? prev.recurrenceWeekDay.filter(
                                              (d) => d !== dayNumber
                                            ) // Remove if already selected
                                          : [
                                              ...prev.recurrenceWeekDay,
                                              dayNumber,
                                            ]; // Add if not selected
                                      return {
                                        ...prev,
                                        recurrenceWeekDay: updatedDays,
                                      };
                                    });
                                  }}
                                />
                                <span>{day}</span>
                              </label>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="col-lg-6">
                      <label htmlFor="StartOn" className="col-form-label">
                        {localizationStrings?.startOn}
                      </label>
                      <DatePicker
                        slotProps={{ textField: {} }}
                        value={
                          editScheduleData?.recurrenceStartDate
                            ? dayjs(editScheduleData?.recurrenceStartDate)
                            : null
                        }
                        onChange={(newValue) =>
                          updateEditScheduleField(
                            "recurrenceStartDate",
                            newValue ? newValue.toISOString() : null
                          )
                        }
                        minDate={dayjs()} // Prevent past dates
                      />
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="EndOn" className="col-form-label">
                        {localizationStrings?.endOn}
                      </label>
                      <DatePicker
                        slotProps={{ textField: {} }}
                        value={
                          editScheduleData?.recurrenceEndDate
                            ? dayjs(editScheduleData?.recurrenceEndDate)
                            : null
                        }
                        onChange={(newValue) =>
                          updateEditScheduleField(
                            "recurrenceEndDate",
                            newValue ? newValue.toISOString() : null
                          )
                        }
                        minDate={
                          editScheduleData?.recurrenceStartDate
                            ? dayjs(editScheduleData?.recurrenceStartDate)
                            : dayjs()
                        }
                      />
                    </div>
                  </LocalizationProvider>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={() => setEditScheduleModel(false)}
                >
                  {localizationStrings?.cancel}
                </button>
                <button
                  type="button"
                  className="text-btn primary-btn"
                  onClick={() => handleUpdateScheduleClick(id)}
                >
                  {localizationStrings?.save}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {deleteScheduleModel && (
        <div className="customModal confirm-modal">
          <div className="modal-dialog modal-dialog-centered small">
            <div className="modal-content inc-modal">
              <div className="modal-body">
                <img src={errorIcon} alt="error" />
                <p>{localizationStrings?.scheduleDeleteInfo}</p>
                <h3>{localizationStrings?.continueMsg}</h3>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline"
                    onClick={() => setDeleteScheduleModel(false)}
                  >
                    No
                  </button>
                  <button
                    className="text-btn primary-btn"
                    onClick={() => deleteSchedule(scheduleId)}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {portModel && info && (
        <div className="customModal">
          <div className="c-modal-dialog modal-dialog-centered medium">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {localizationStrings?.applySchedule}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setPortModel(false)}
                ></button>
              </div>
              <div className="modal-body">
                {/* Display device information */}
                {info?.switchDetails?.length > 0 ? (
                  info.switchDetails.map((device, idx) => (
                    <div className="device-info" key={`device-${idx}`}>
                      <p>
                        <strong>
                          {localizationStrings?.deviceSerialNumber}
                        </strong>{" "}
                        {device.serial_number || "N/A"}
                      </p>
                      <p>
                        <strong>{localizationStrings?.deviceId}</strong>{" "}
                        {device.device_id || "N/A"}
                      </p>
                    </div>
                  ))
                ) : (
                  <div className="no-device-info">
                    <p>{localizationStrings?.noDeviceInfo}</p>
                  </div>
                )}

                <p>{localizationStrings?.postSelectInfo}</p>
                <ul>
                  <li>{localizationStrings?.selectedPorts}</li>
                  <li>{localizationStrings?.unSelectedPorts}</li>
                </ul>

                {/* Render Ports */}
                {info?.switchDetails?.length > 0 &&
                  info.switchDetails.map((device) => (
                    <div key={device.device_id}>
                      <div className="mb-2 router-port">
                        <div className="mxw-850">
                          <div className="polygon"></div>
                          <div className="port-box">
                            <ul className="port24">
                              {[...Array(device.no_of_ports)].map(
                                (_, index) => {
                                  const portNumber = (index + 1).toString();
                                  const isAssigned =
                                    assignedPorts[portNumber] || false; // Default to unassigned
                                  return (
                                    <li
                                      key={portNumber}
                                      className={
                                        isAssigned ? "assign" : "unassign"
                                      }
                                      onClick={() => togglePort(portNumber)}
                                    >
                                      {portNumber}
                                    </li>
                                  );
                                }
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={() => setPortModel(false)}
                >
                  {localizationStrings?.cancel}
                </button>
                <button
                  type="submit"
                  className="text-btn primary-btn"
                  onClick={() => addApplySchedule()}
                >
                  {localizationStrings?.save}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {editPortModel && (
        <div className="customModal">
          <div className="c-modal-dialog modal-dialog-centered medium">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {localizationStrings?.editPorts}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditPortModel(false)}
                ></button>
              </div>
              <div className="modal-body">
                {/* Display Device ID */}
                <p>
                  <strong>{localizationStrings?.deviceId}</strong>{" "}
                  {editPortsData.deviceId}
                </p>
                <p>{localizationStrings?.postSelectInfo}</p>
                <ul>
                  <li>{localizationStrings?.selectedPorts}</li>
                  <li>{localizationStrings?.unselectedPorts}</li>
                </ul>
                {editPortsData.portDetails.length > 0 ? (
                  <div className="mb-2 router-port">
                    <div className="mxw-650">
                      <div className="polygon"></div>
                      <div className="port-box">
                        <ul className="port54">
                          {[...Array(54)].map((_, index) => {
                            const portNumber = (index + 1).toString();
                            const isAssigned =
                              assignedEditPorts[portNumber] || false;
                            return (
                              <li
                                key={portNumber}
                                className={isAssigned ? "assign" : "unassign"}
                                onClick={() => toggleEditPort(portNumber)}
                              >
                                {portNumber}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                ) : (
                  <p>{localizationStrings?.noSwitchInfo}</p>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={() => setEditPortModel(false)}
                >
                  {localizationStrings?.cancel}
                </button>
                <button
                  type="submit"
                  className="text-btn primary-btn"
                  onClick={(schedule) =>
                    handleUpdatePortClick(
                      editPortsData,
                      assignedEditPorts,
                      schedule.swSchdId
                    )
                  } // Replace 3 with dynamic scheduleId
                >
                  {localizationStrings?.save}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showScheduleFailurePopup && (
              <div className="customModal confirm-modal">
                <div className="modal-dialog modal-dialog-centered small">
                  <div className="modal-content inc-modal">
                    <div className="modal-body">
                      <img src={errorIcon} alt="error" />
                      <h3>{localizationStrings?.ScheduleCreationFailed}.</h3>
                      <div className="modal-footer">
                        <button
                          className="text-btn primary-btn"
                          onClick={() => setShowScheduleFailurePopup(false)}
                        >
                          {localizationStrings?.close}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {showEditFailurePopup && (
              <div className="customModal confirm-modal">
                <div className="modal-dialog modal-dialog-centered small">
                  <div className="modal-content inc-modal">
                    <div className="modal-body">
                      <img src={errorIcon} alt="error" />
                      <h3>{localizationStrings?.ScheduleCreationFailed}.</h3>
                      <div className="modal-footer">
                        <button
                          className="text-btn primary-btn"
                          onClick={() => setShowEditFailurePopup(false)}
                        >
                          {localizationStrings?.close}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
      <Modal
        show={showSuccessPopup}
        onHide={handleCancelPopUp}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert index-2000"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.scheduleCreatedSuccessfully}</p>
        <Button
          onClick={() => {
            handleCancelPopUp();
            fetchSchedule();
          }}
        >
          {localizationStrings?.ok}
        </Button>
      </Modal>
      <Modal
        show={showEditPortSuccessPopup}
        onHide={handleCancelPopUp}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert index-2000"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.portDetailsChangedSuccessfully}</p>
        <Button onClick={handleCancelPopUp}>{localizationStrings?.ok}</Button>
      </Modal>
      <Modal
        show={showEditSuccessPopup}
        onHide={handleCancelPopUp}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert index-2000"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.scheduleEditedSuccessfully}</p>
        <Button onClick={handleCancelPopUp}>{localizationStrings?.ok}</Button>
      </Modal>
    </div>
  );
}

export default DowntimeSchedules;
